import React from 'react';

interface TimeLostLegendProps {
  /** Position of the legend - defaults to bottom-right */
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  /** Container width for positioning calculations */
  containerWidth: number;
  /** Container height for positioning calculations */
  containerHeight: number;
}

const TimeLostLegend: React.FC<TimeLostLegendProps> = ({
  position = 'bottom-right',
  containerWidth,
  containerHeight
}) => {
  // Calculate position based on prop
  const getTransform = () => {
    const margin = 15;
    switch (position) {
      case 'bottom-right':
        return `translate(${containerWidth - margin}, ${containerHeight - margin})`;
      case 'bottom-left':
        return `translate(${margin + 110}, ${containerHeight - margin})`;
      case 'top-right':
        return `translate(${containerWidth - margin}, ${margin + 35})`;
      case 'top-left':
        return `translate(${margin + 110}, ${margin + 35})`;
      default:
        return `translate(${containerWidth - margin}, ${containerHeight - margin})`;
    }
  };

  return (
    <g style={{ pointerEvents: 'none' }}>
      <g transform={getTransform()}>
        {/* Black background box with rounded edges */}
        <rect
          x="-110"
          y="-35"
          width="110"
          height="35"
          fill="rgba(0, 0, 0, 0.8)"
          rx="8"
        />
        
        {/* Title */}
        <text
          x="-55"
          y="-24"
          fill="white"
          fontSize="11"
          textAnchor="middle"
          fontFamily="inherit"
          fontWeight="500"
          dominantBaseline="middle"
        >
          Time Lost
        </text>
        
        {/* Smooth gradient bar */}
        <rect
          x="-95"
          y="-16"
          width="80"
          height="8"
          fill="url(#timeLostGradient)"
          rx="4"
        />
      </g>
    </g>
  );
};

export default TimeLostLegend;
